import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, styled, Tooltip } from '@mui/material';
const StyledImage = styled('img') `
  height: 24px;
  margin: 3px;
`;
const StyledPaper = styled(Paper) `
  display: flex;
  align-items: center;
  padding: ${({ noBorder }) => (noBorder ? '0' : '4px 8px 4px 4px')};
  font-weight: 600;
`;
const getGameResultDimensionCode = (gameKey, pillPosition) => {
    if ((gameKey === 'madden-25' || gameKey === 'madden-26') && pillPosition === 'right') {
        return 'ovr_ranges';
    }
    return undefined;
};
export const isGameResultDimensionToShow = (gameKey, pillPosition) => !!getGameResultDimensionCode(gameKey, pillPosition);
const TournamentBoxPillGameResultDimension = ({ tournament, pillPosition, noBorder, }) => {
    var _a;
    const gameKey = tournament.score_template.game.game_key;
    const gameResultDimensionCode = getGameResultDimensionCode(gameKey, pillPosition);
    if (!gameResultDimensionCode) {
        return null;
    }
    const gameResultCondition = tournament.score_template.gameResultConditions.find((condition) => condition.gameResultDimension.code === gameResultDimensionCode);
    if (!gameResultCondition) {
        return null;
    }
    if (gameResultCondition.aggregatedValues) {
        const label = gameResultCondition.aggregatedValues.map((aggr) => aggr.displayName).join(', ');
        return (_jsxs(StyledPaper, { elevation: noBorder ? 0 : 2, noBorder: noBorder, children: [_jsx(Tooltip, { placement: "top", arrow: true, title: label, children: _jsx(StyledImage, { src: (_a = gameResultCondition.gameResultDimension.displayIconImageUrl) !== null && _a !== void 0 ? _a : undefined }) }), label] }));
    }
    // future work
    return null;
};
export default TournamentBoxPillGameResultDimension;
